<template>
  <div class="elevation-5 signing">
    <div class="logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="sign-box">
      <div class="input-box">
        <div class="form-input">
          <v-text-field
            v-model="email"
            placeholder="Staff ID"
            :rules="emailRules"
            full-width
            @keyup.enter="signin"
          ></v-text-field>
        </div>
        <div class="form-input">
          <v-text-field
            v-model="password"
            placeholder="Password"
            type="password"
            :rules="passwordRules"
            @keyup.enter="signin"
          ></v-text-field>
        </div>
        <v-btn
          class="btn-login"
          large block
          @click.native="signin"
        >LOGIN</v-btn>
      </div>
      <div class="help-box">
        <router-link :to="{ name: 'pwdReset' }">
          <button>
            Forgot password?
          </button>
        </router-link>
      </div>
    </div>
    <p class="copyright">COPYRIGHT ⓒImGATE ALL RIGHTS RESERVED.</p>
  </div>
</template>

<script>
  import api from '../../api';

  export default {
    data() {
      return {
        // url: `${process.env.API_ENDPOINT}/admins/session`,
        email: null,
        password: null,
        emailRules: [
          v => (v === 0) || !!v || 'Please input Email',
          /* eslint max-len: ["error", { "code": 200 }] */
          v => /^\w+([\\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
          v => (v === 0) || !!v || 'Please input Password',
        ],
      };
    },
    methods: {
      signin() {
        console.log('signIn');
        const params = {
          email: this.email,
          password: this.password,
        };
        api.signin(params)
        .then((result) => {
          if (result.status === 200) {
            localStorage.setItem('apikey', result.data.api_key);
            localStorage.setItem('domain_type', result.data.domain_type);
            localStorage.setItem('domain_id', result.data.domain_id);
            localStorage.setItem('name', result.data.name);
            localStorage.setItem('desc', result.data.desc);
            localStorage.setItem('id', result.data.id);
            localStorage.setItem('email', result.data.email);
            localStorage.setItem('accessTime', this.$moment().format('A hh:mm:ss'));
            this.$router.push({ name: 'bookings' });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/signing/SignIn.vue